/**
 * IMPORTS
 */
import { z } from "zod";

type RemessaSelecionadaLote = {
  id: number;
  remessa: number;
  numero_remessa: string | number;
  cliente?: string;
  cliente_id?: number;
  cliente_name?: string;
  tipo_entrega?: { tipo?: string; tipo_entrega_id?: number; id?: number } | string;
  liberacao_expedicao?: {
    tipo_entrega_id?: number;
    observacao?: string | null;
    outros?: string | null;
  } | null;
  data_fim_producao?: string;
};

type BatchFinalizeModalProps = {
  modulo: "expedicao" | "recepcao";
  remessas: RemessaSelecionadaLote[];
  handleClose: () => void;
  onSuccess: () => void;
};

export const schema = z.object({
  observacao: z.string().min(10, "A mensagem deve ter no mínimo 10 caracteres."),
});

type FormData = z.infer<typeof schema>;

/**
 * EXPORTS
 */
export type { BatchFinalizeModalProps, FormData, RemessaSelecionadaLote };
